export enum MODULES {
  ADMINISTRATION = "administration",
  MAIN = "main",
  CHANGEMAN = "changeman",
  CHEFS_ASSISTANT = "chefs_assistant",
  HEALTH = "health",
  HELPDESK = "helpdesk",
  OVERVIEW = "overview",
}

export enum ACCESS_PROFILE_MODULES {
  ADMINISTRATION = "Administração",
  CHANGEMAN = "Changeman",
  CHEFS_ASSISTANT = "Restaurante",
  HEALTH = "Clínica",
  HELPDESK = "HelpDesk",
  OVERVIEW = "Overview",
}

export enum ACCESS_PROFILE {
  administrador = "administrador", // module full access
  manager = "gerente", // module group access
  user = "usuário", // module property access
}

export type UserModules = {
  [key in MODULES]: string;
};

export const modulesDefault: UserModules = Object.fromEntries(
  Object.values(MODULES).map(key => [key, ""]),
) as UserModules;
